import { render, staticRenderFns } from "./Comments.vue?vue&type=template&id=1bf20a24&scoped=true&"
import script from "./Comments.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Comments.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf20a24",
  null
  
)

export default component.exports